import { rootApi } from "../rootApi";

export const currentAccountReportApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentAccountReport: builder.query({
      query: (params) => ({
        url: "v1/accoutingreport/cari-report",
        method: "GET",
        params
      }),
      transformResponse: (resp) =>
        resp?.data ?? { items: [], totalCount: 0 },
      providesTags: (result) =>
        result?.items
          ? [
              ...result.items.map((_, i) => ({ type: "CurrentAccountReport", id: i })),
              { type: "CurrentAccountReport", id: "LIST" }
            ]
          : [{ type: "CurrentAccountReport", id: "LIST" }]
    }),

    exportCurrentAccountReportToExcel: builder.query({
      query: ({ startDate = null, endDate = null, compressionType = null, LanguageId = null } = {}) => {
        const p = new URLSearchParams();
        if (startDate) p.set("StartDate", startDate);
        if (endDate) p.set("EndDate", endDate);
        if (compressionType != null) p.set("CompressionType", compressionType);
        if (LanguageId != null) p.set("LanguageId", LanguageId);
        return { url: `v1/accoutingreport/export-cari-report?${p.toString()}`, method: "GET" };
      },
      transformResponse: (resp) => {
        const data = resp?.data ?? {};
        return {
          fileBase64: data.fileBase64,
          fileName: data.fileName,
          contentType: data.contentType,
          recordCount: data.recordCount,
          fileSize: data.fileSize,
        };
      },
    }),
  })
});

export const {
  useGetCurrentAccountReportQuery,
  useLazyExportCurrentAccountReportToExcelQuery
} = currentAccountReportApi;
